<template>
  <v-container fluid>
    <v-card :loading="loadSkeleton">
      <v-card-title class="d-flex justify-between space-between" style="justify-content: space-between;">
        <span class="text-h6">Gestión de Testimonios</span>
        <v-btn-toggle v-model="viewMode" mandatory>
          <v-btn value="grid" icon title="Vista de Mosaico">
            <v-icon>mdi-view-grid</v-icon>
          </v-btn>
          <v-btn value="list" icon title="Vista de Lista">
            <v-icon>mdi-view-list</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-card-title>

      <div class="d-flex justify-space-between align-center mt-4 px-2 space-between">
        <v-pagination
          v-model="page"
          :length="Math.ceil(totalItems / itemsPerPage)"
          :total-visible="7"
          :loading="true"
        ></v-pagination>
        <v-select
          v-model="itemsPerPage"
          :items="[8, 16, 32, 64, 128]"
          variant="outlined"
          label="Ítems por página"
          dense
          style="max-width: 100px"
          @update:modelValue="onItemsPerPageChange"
        />
      </div>

      <v-tabs  v-model="tab" align-tabs="center" fixed-tabs grow @click="openTab(tab)" >
        <v-tab value="HOME"><b>HOME</b></v-tab>
        <v-tab value="CRIS"><b>CRIS</b></v-tab>
      </v-tabs> 

      <v-tabs-window v-model="tab">
        <v-tabs-window-item
          v-for="(images, type) in groupedTestimonial"
          :key="type"
          :value="type"
        >
          <v-container fluid>
            <v-row v-if="viewMode === 'grid'">
              <v-col
                v-for="testimonial in images"
                :key="testimonial.id"
                cols="12" sm="6" md="4" lg="3"
              >
                <v-skeleton-loader :loading="loadSkeleton" height="240" type="image, list-item-two-line">
                  <v-responsive>
                    <v-card>
                      <v-img
                        :src="getImagePath(testimonial.image)"
                        height="200px"
                        cover
                      />
                      <v-card-title class="text-subtitle-1">#{{testimonial.id}} {{ testimonial.couple }}</v-card-title>
                      <v-card-subtitle :title="testimonial.verse">{{ testimonial.verse }}</v-card-subtitle>
                      <v-card-text :title="testimonial.quote">
                        {{ cortarTexto(testimonial.quote, 40) }}
                      </v-card-text>
                      <v-card-subtitle><strong>rating :</strong> 
                        <v-rating
                          half-increments
                          hover
                          :length="5"
                          :size="15" 
                          v-model="testimonial.rating"
                          active-color="primary"
                          readonly
                        />
                      </v-card-subtitle>
                      <v-card-subtitle><strong>Estado :</strong> {{ testimonial.status === 'A' ? 'Activo' : 'Inactivo' }}</v-card-subtitle>
                      <v-card-subtitle><strong>fecha :</strong> {{ testimonial.date }}</v-card-subtitle>
                      <v-card-actions>
                        <v-btn icon="mdi-eye" @click="previewImage(getImagePath(testimonial.image))" />
                        <v-spacer />
                        <v-btn icon="mdi-pencil" color="primary" @click="openEditDialog(testimonial)" />
                        <v-spacer />
                        <v-btn icon="mdi-delete" color="red" @click="confirmDelete(testimonial.id || -1)" />
                      </v-card-actions>
                    </v-card>
                  </v-responsive>
                </v-skeleton-loader>
              </v-col>
            </v-row>

            <v-row v-else>
              <v-col cols="12">
                <v-skeleton-loader :loading="loadSkeleton" type="article">
                  <v-table density="compact" class="mt-4" style="width: -webkit-fill-available;">
                    <thead>
                      <tr>
                        <th>id</th>
                        <th>image</th>
                        <th>rating</th>
                        <th>Pareja</th>
                        <th>Referencias</th>
                        <th>Versículo</th>
                        <th>Fecha</th>
                        <th>Tipo</th>
                        <th>Cita</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="testimonial in images" :key="testimonial.id">
                        <td>{{ testimonial.id }}</td>
                        <td style="width: 120px">
                          <v-img :src="getImagePath(testimonial.image)" height="60" cover />
                        </td>
                        <td>{{ testimonial.rating }}</td>
                        <td>{{ testimonial.couple }}</td>
                        <td>{{ testimonial.verse_references }}</td>
                        <td :title="testimonial.verse">{{ testimonial.verse }}</td>
                        <td>{{ testimonial.date }}</td>
                        <td>{{ testimonial.type }}</td>
                        <td :title="testimonial.quote">
                          {{ cortarTexto(testimonial.quote, 20) }} 
                        </td>
                        <td>{{ testimonial.status }}</td>
                        <td>
                          <v-menu>
                            <template v-slot:activator="{ props }">
                              <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"></v-btn>
                            </template>
                            <v-card>
                              <v-list>
                                <v-list-subheader>OPCIONES</v-list-subheader>
                                <v-list-item @click="previewImage(getImagePath(testimonial.image))">
                                  <v-list-item-title>Ver</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="openEditDialog(testimonial)">
                                  <v-list-item-title>Editar</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="confirmDelete(testimonial?.id || -1)">
                                  <v-list-item-title>Eliminar</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-card>
                          </v-menu>
                        </td>
                      </tr>
                    </tbody>
                  </v-table>
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </v-container>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-card>

    <!-- FAB flotantes -->
    <div class="fab-container">
      <v-fab
        icon="mdi-reload"
        size="small"
        color="primary"
        @click="cargarTestimonios()"
      />
      <v-fab
        icon="mdi-plus"
        size="small"
        color="secondary"
        @click="openUploadDialog(tab)"
      />
    </div>


    <!-- Diálogo de previsualización -->
    <v-dialog v-model="dialogPreview" max-width="800" scrollable>
      <v-card>
        <v-img :src="previewUrl" height="auto" cover />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogPreview = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de formulario -->
    <v-dialog v-model="dialogEdit" max-width="800px" persistent>
      <v-card>
        <v-card-title>{{ isEdit ? 'Editar Imagen' : 'Agregar Imagen' }}</v-card-title>
        <v-card-text>
          <TestimonialForm
            v-model="formData"
            :isEdit="isEdit"
            :loading="loader" 
            @submit="editarTestimonios"
            @submit2="guardarTestimonios"
            @cancel="() => dialogEdit = false"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo de confirmación -->
    <v-dialog v-model="dialogConfirm" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h6">¿Está seguro que desea eliminar el testimonio con ID <b>#{{ itemToDelete }}</b>?</v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn color="red" text @click="performDelete">Eliminar</v-btn>
          <v-btn color="grey" text @click="dialogConfirm = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup lang="ts">
import TestimonialForm from '@/components/TestimonialForm.vue'
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { HOST_URL_IMGS } from '@/utils/constantes'
import { ITestimonial } from '@/interfaces/testimonials.interface'

const store = useStore()
const router = useRouter()
const testimonials = computed(() => store.state.Testimonials.TestimonialsList)
const statusInsertTestimonials = computed(() => store.state.Testimonials.statusInsertTestimonials)
const statusUpdateTestimonials = computed(() => store.state.Testimonials.statusUpdateTestimonials)
const statusDelTestimonials = computed(() => store.state.Testimonials.statusDelTestimonials)
// const estado = computed(() => store.state.Ui.status)


const dialogConfirm = ref(false)
const itemToDelete = ref<number | null>(null)
const aTestimonials = ref<ITestimonial[]>([])
const dialogPreview = ref(false)
const previewUrl = ref('')
const newImage = ref<File | null>(null)
const uploadType = ref<string>('')
const viewMode = ref<'grid' | 'list'>('grid')
const dialogEdit = ref(false)
const tab = ref<string>('HOME')
const loader = ref(false)
const snackbar = ref(false)
// const snackbarText = ref('')
const loadSkeleton = ref(false)

const totalItems = computed(() => store.state.Testimonials.totalItems)
const page = ref(1)
const itemsPerPage = ref(8)
const isEdit = ref(false)

const formData = ref<ITestimonial>({
  quote: '',
  rating: 0,
  couple: '',
  verse_references: '',
  verse: '',
  image: '',
  date: new Date().toISOString().split('T')[0], // formato YYYY-MM-DD
  type: '',
  status: 'A', // o 'inactive', según tu lógica
})

function openTab(newTab: string) {
  tab.value = newTab
  itemsPerPage.value = 8
  page.value = 1
  cargarTestimonios()
}
async function cargarTestimonios() {
  loadSkeleton.value = true
  await store.dispatch('Testimonials/fetchTestimonials', {
    params: {
      page: page.value,
      limit: itemsPerPage.value,
      type: tab.value,
    }
  })
  
  aTestimonials.value = testimonials.value?.data.items ?? []
  loadSkeleton.value = false
}

 
async function guardarTestimonios({ data, imageFile }: { data: ITestimonial; imageFile: File | null }) {
  loader.value = true
const pad = (n: any) => n.toString().padStart(2, '0');
const date = new Date(data.date);
const formatted = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate() + 1)}`;
  const formData = new FormData()
  formData.append('quote', data.quote ?? '')
  formData.append('rating', String(data.rating))
  formData.append('couple', data.couple ?? '')
  formData.append('verse_references', data.verse_references ?? '')
  formData.append('verse', data.verse ?? '')
  formData.append('date', String(formatted))
  formData.append('type', data.type)
  formData.append('status', data.status ?? 'A')
  if (imageFile) {
    formData.append('image', imageFile)
  } else if (data.image && !data.image.startsWith('http')) {
    try {
      const image = await urlToFile(getImagePath(data.image), data.image)
      formData.append('image', image)
    } catch (error) {
      console.error('Error convirtiendo imagen existente en archivo:', error)
    }
  }
  await store.dispatch('Testimonials/postTestimonials', formData)
  loader.value = false
  if (statusInsertTestimonials.value?.success) {
    dialogEdit.value = false
    cargarTestimonios()
  }
}

async function editarTestimonios({ data, imageFile }: { data: ITestimonial; imageFile: File | null }) {
  loader.value = true
  const pad = (n: any) => n.toString().padStart(2, '0');
  const date = new Date(data.date);
  const formatted = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate() + 1)}`;
  const formData = new FormData()
  formData.append('quote', data.quote ?? '')
  formData.append('rating', String(data.rating))
  formData.append('couple', data.couple ?? '')
  formData.append('verse_references', data.verse_references ?? '')
  formData.append('verse', data.verse ?? '')
  formData.append('date', String(formatted))
  formData.append('type', data.type)
  formData.append('status', data.status ?? 'A')
  if (imageFile) {
    formData.append('image', imageFile)
  } else if (data.image && !data.image.startsWith('http')) {
    try {
      const image = await urlToFile(getImagePath(data.image), data.image)
      formData.append('image', image)
    } catch (error) {
      console.error('Error convirtiendo imagen existente en archivo:', error)
    }
  }
  await store.dispatch('Testimonials/putTestimonial', {
    id: data.id,
    formData
  })
  loader.value = false  
  if (statusUpdateTestimonials.value?.success) {
    dialogEdit.value = false
    cargarTestimonios()
  }
}

async function deleteTestimonial(id: number) {
  await store.dispatch('Testimonials/delTestimonial', id)
  loader.value = false
  if (statusDelTestimonials.value?.success) {
    dialogConfirm.value = false
    cargarTestimonios()
  }
}

async function urlToFile(url: string, filename: string, mimeType = 'image/jpeg'): Promise<File> {
  const response = await fetch(url)
  const blob = await response.blob()
  return new File([blob], filename.split('/').pop() || 'image.jpg', { type: mimeType })
}
const confirmDelete = (id: number) => {
  itemToDelete.value = id
  dialogConfirm.value = true
}
const onItemsPerPageChange = () => {
  page.value = 1
  cargarTestimonios()
}
const performDelete = () => {
  if (itemToDelete.value !== null) {
    deleteTestimonial(itemToDelete.value)
    dialogConfirm.value = false
    itemToDelete.value = null
  }
}
function openUploadDialog(type: string) {
  isEdit.value = false
  uploadType.value = type
  formData.value = {
    quote: '',
    rating: 5,
    couple: '',
    verse_references: '',
    verse: '',
    image: '',
    date: new Date().toISOString().split('T')[0], // formato YYYY-MM-DD
    type: 'HOME',
    status: 'A', // o 'inactive', según tu lógica
  }
  dialogEdit.value = true
  newImage.value = null
}
const groupedTestimonial = computed(() => {
  if (!aTestimonials.value || !Array.isArray(aTestimonials.value)) return {}
  return aTestimonials.value.reduce<Record<string, ITestimonial[]>>((acc, item) => {
    if (!acc[item.type]) acc[item.type] = []
    acc[item.type].push(item)
    return acc
  }, {})
})
function getImagePath(path: string) {
  const baseURL = `${HOST_URL_IMGS}/public/imgs/output`
  return path.startsWith('http') ? path : baseURL + '/' + path
}
function previewImage(url: string) {
  previewUrl.value = url
  dialogPreview.value = true
}
watch(page, () => {
  cargarTestimonios()
})

function openEditDialog(g: ITestimonial) {
  isEdit.value = true
  formData.value = { ...g }
  dialogEdit.value = true
}
function cortarTexto(texto: string, max = 10) {
  return texto.length > max ? texto.slice(0, max) + '...' : texto
}
onMounted(() => {
  cargarTestimonios()
})
</script>

<style scoped>
html {
  contain: layout style;
}
.fab-container {
  position: fixed;
  bottom: 24px;
  left: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 9999;
}
</style>
